import GoogleMap from "../utils/map";
import Form from "../modules/form";

const Contacts = {
  init() {
    new Form("#contact-form");
    Contacts.renderMap();
    Contacts.events();

  },

  events() {
    // Switches radio button value.
    $('.field--radio').on('click', (e) => {
      let inputBtn = $(e.target).parent().find('input').data('id');
      $('#personType').val(inputBtn);
    });
  },

  renderMap() {
    const mapEl = $("#map-wrap");

    if (!mapEl.length) {
      return;
    }

    const data = {
      lat: mapEl.data("lat"),
      lng: mapEl.data("lng"),
      zoom: mapEl.data("zoom"),
    };

    GoogleMap.create(data, mapEl);
  },
};

export default Contacts;
